const getQueryParams = params => {
  if (typeof params !== "object") {
    return ""
  }
  return Object.entries(params)
    .map(([key, value]) => {
      return `${key}=${value}`
    })
    .join("&")
}

export default getQueryParams
